// tables — see README.md. Keys must exist in BOTH maps (checked by npm run check:locales).
export const en = {
  // --- Floor plan designer: the two booking-channel switches on a table ----
  'tables.designer.reservations': 'Phone / desk reservations',
  'tables.designer.website': 'Website booking',
  'tables.designer.allowed': 'Allowed',
  'tables.designer.notAllowed': 'Not allowed',
  'tables.designer.channelsHint': 'Which channels may book this table. Not allowed hides it from that channel’s table picker and from automatic seating, and a booking that names it is refused.',
  // --- All Reservations: a table on the payment clock ---------------------
  'tables.resv.held': 'Held — paying',
  'tables.resv.heldUntil': 'held until {time}',
  'tables.audit.paymentExpired': 'Auto-cancelled — payment window ran out',
  'tables.audit.blacklisted': 'Guest blacklisted — too many no-shows',
  // --- Shared by the tables & reservations screens -------------------------
  'tables.guest': 'Guest',
  'tables.pax': '{n} pax',
  'tables.seats': '{n} seats',
  'tables.close': 'Close',
  'tables.error.title': 'Error',
  'tables.error.generic': 'Something went wrong. Please try again.',

  // --- Tables view: page chrome -------------------------------------------
  'tables.loading': 'Loading tables...',
  'tables.title': 'Tables Management',
  'tables.locationFallback': 'Location {id}',
  'tables.stats.totalTables': 'Total Tables',
  'tables.stats.totalSeats': 'Total Seats',
  'tables.stats.available': 'Available',
  'tables.stats.occupied': 'Occupied',
  'tables.fetchFailed': 'Failed to fetch tables',
  'tables.empty': 'No tables set up for this location yet. Add them in Seating → Layout.',
  'tables.floor.tableCount': '({n} tables)',
  'tables.section.one': '{name} · 1 table',
  'tables.section.many': '{name} · {n} tables',

  // Reservation hold time card
  'tables.hold.label': 'Reservation hold time',
  'tables.hold.minutes': 'minutes',
  'tables.hold.preset.min': '{n}m',
  'tables.hold.preset.hour1': '1 hr',
  'tables.hold.preset.hour15': '1.5 hr',
  'tables.hold.preset.hour2': '2 hr',
  'tables.hold.saved': 'Saved ✓',
  'tables.hold.help': 'How long a guest\'s QR check-in reserves the table before it auto-frees.',
  'tables.hold.saveFailed.title': 'Could not save',
  'tables.hold.saveFailed.desc': 'Failed to update the reservation time.',

  // --- Table card ----------------------------------------------------------
  'tables.card.viewOrders': 'View this table\'s orders',
  'tables.card.shared.one': 'SHARED · {n} party',
  'tables.card.shared.many': 'SHARED · {n} parties',
  'tables.sharing': 'sharing',
  'tables.takenBy': 'Taken by {name}',
  'tables.orderedBy': 'Ordered by {name}',
  'tables.bookTable': 'Book Table',
  'tables.freeTable': 'Free Table',

  // Table status badge — the LABEL only; the stored value never changes.
  'tables.status.available': 'AVAILABLE',
  'tables.status.reserved': 'RESERVED',
  'tables.status.occupied': 'OCCUPIED',
  'tables.status.partial': 'PARTIAL',

  // Order status badge labels
  'tables.orderStatus.pending': 'PENDING',
  'tables.orderStatus.ordered': 'ORDERED',
  'tables.orderStatus.confirmed': 'CONFIRMED',
  'tables.orderStatus.preparing': 'PREPARING',
  'tables.orderStatus.ready': 'READY',
  'tables.orderStatus.served': 'SERVED',
  'tables.orderStatus.cancelled': 'CANCELLED',
  'tables.orderStatus.completed': 'COMPLETED',
  'tables.orderStatus.voided': 'VOIDED',
  'tables.orderStatus.servedBillOpen': 'SERVED — bill open',

  // Per-line (dish) status labels
  'tables.itemStatus.pending': 'PENDING',
  'tables.itemStatus.preparing': 'PREPARING',
  'tables.itemStatus.ready': 'READY',
  'tables.itemStatus.served': 'SERVED',
  'tables.itemStatus.held': 'HELD',

  // Per-line service clock
  'tables.clock.orderedServed': 'ordered {at} → served {served} · {mins}m',
  'tables.clock.orderedServedNoMins': 'ordered {at} → served {served}',
  'tables.clock.servedTimeUnknown': 'ordered {at} → served (time not recorded)',
  'tables.clock.orderedState': 'ordered {at} · {state} {mins}m',
  'tables.clock.orderedOnly': 'ordered {at}',
  'tables.clock.state.waiting': 'waiting',
  'tables.clock.state.cooking': 'cooking',
  'tables.clock.state.ready': 'ready at the pass',

  // --- Free table / book table -------------------------------------------
  'tables.free.title': 'Free table {code}?',
  'tables.free.desc': 'This ends the guests\' sitting and makes the table available again.',
  'tables.free.descUnserved.one': ' The table still has 1 unserved order — you\'ll choose next whether to cancel it.',
  'tables.free.descUnserved.many': ' The table still has {n} unserved orders — you\'ll choose next whether to cancel them.',
  'tables.free.confirm': 'Free table',
  'tables.free.cancelTitle.one': 'Cancel the unserved order?',
  'tables.free.cancelTitle.many': 'Cancel all {n} unserved orders?',
  'tables.free.cancelDesc.one': '{orders} has not been served yet. ',
  'tables.free.cancelDesc.many': '{orders} have not been served yet. ',
  'tables.free.cancelDesc.explain': 'Cancel: the kitchen stops and the cancellation is recorded on the order. Keep: the kitchen keeps preparing and the order stays open.',
  'tables.free.cancelConfirm.one': 'Cancel order',
  'tables.free.cancelConfirm.many': 'Cancel orders',
  'tables.free.keepOrders': 'Keep orders',
  'tables.free.failed': 'Could not free the table',
  'tables.book.failed': 'Failed to book table: {msg}',

  // --- Marking food served -------------------------------------------------
  'tables.serve.orderFailed.title': 'Could not mark served',
  'tables.serve.orderFailed.desc': 'The order did not update — try again.',
  'tables.serve.itemFailed.title': 'Could not mark the dish served',
  'tables.serve.itemFailed.desc': 'The dish did not update — try again.',

  // --- Table order sheet ---------------------------------------------------
  'tables.detail.loadFailed': 'Failed to load orders for this table.',
  'tables.detail.title': '{code} — Orders',
  'tables.detail.shared': 'SHARED · {n} parties',
  'tables.detail.loading': 'Loading orders…',
  'tables.detail.activeOrders': 'Active orders ({n})',
  'tables.detail.noActive': 'No active orders on this table.',
  'tables.detail.noneFromParty': 'No orders yet from this party.',
  'tables.detail.otherActive': 'Other active orders',
  'tables.detail.history': 'Order history ({n})',
  'tables.detail.noHistory': 'No past orders on this table yet.',
  'tables.order.markServed': '✅ Mark served — guest has it',
  'tables.order.generateBill': 'Generate bill — close order',
  'tables.order.for': 'for',
  'tables.order.serveItem': '✓ Serve',
  'tables.order.comesWith': 'Comes with {items}',
  'tables.order.total': 'Total',

  // --- Bill ---------------------------------------------------------------
  'tables.bill.loadFailed': 'Could not load the bill.',
  'tables.bill.title': 'Bill · {number}',
  'tables.bill.table': 'Table {code}',
  'tables.bill.working': 'Working out the bill…',
  'tables.bill.subtotal': 'Subtotal',
  'tables.bill.advance': 'Booking advance',
  'tables.bill.advanceAdjusted': 'Booking advance (adjusted)',
  'tables.bill.paid': 'Paid',
  'tables.bill.due': 'Amount due',
  'tables.bill.paidClosed': 'PAID — ORDER CLOSED',
  'tables.bill.print': 'Print bill',
  'tables.bill.closing': 'Closing…',
  'tables.bill.markPaid': 'Mark paid & close order',
  'tables.bill.note': 'Print first if the guest wants to see it. Mark paid closes the order and spends any booking advance; the table stays seated until you free it.',
  'tables.bill.closeFailed.title': 'Could not close the order',
  'tables.bill.closeFailed.desc': 'The order did not update — try again.',
  'tables.print.blocked.title': 'Pop-up blocked',
  'tables.print.blocked.desc': 'Allow pop-ups for this site to print the bill.',

  // --- Guest card ----------------------------------------------------------
  'tables.guestLink.title': 'See this guest\'s details',
  'tables.guestCard.loadFailed': 'Could not load this guest.',
  'tables.guestCard.registered': 'Registered guest',
  'tables.guestCard.inactive': 'Inactive account',
  'tables.guestCard.looking': 'Looking up this guest…',
  'tables.guestCard.notRegisteredPhone': 'Not a registered guest — only the name was taken with the booking, and the number is not in the customer register yet.',
  'tables.guestCard.notRegisteredNoPhone': 'Not a registered guest — only the name was taken with the order, so there is no phone number on file.',
  'tables.guestCard.noEmail': 'no email',
  'tables.guestCard.visits': 'Visits',
  'tables.guestCard.totalSpend': 'Total spend',
  'tables.guestCard.avgOrder': 'Avg order',
  'tables.guestCard.lastVisit': 'Last visit',
  'tables.guestCard.usualParty': 'Usual party',
  'tables.guestCard.noShows': 'No-shows',
  'tables.guestCard.advanceHeld': 'Booking advance held:',
  'tables.guestCard.advanceNote': ' — deducted from their next bill',
  'tables.guestCard.favourites': 'Favourite dishes',
  'tables.guestCard.openCrm': 'Open full CRM profile',

  // --- Booking modal (tables view) ----------------------------------------
  'tables.booking.title': 'Book {code}',
  'tables.booking.type': 'Booking Type',
  'tables.booking.immediate': 'Immediate',
  'tables.booking.immediateHint': 'Seat guests now',
  'tables.booking.appointment': 'Appointment',
  'tables.booking.appointmentHint': 'Reserve for later',
  'tables.booking.dateTime': 'Appointment Date & Time',
  'tables.booking.selected': 'Selected:',
  'tables.booking.guests': 'Number of Guests',
  'tables.booking.guestsPlaceholder': 'How many guests?',
  'tables.booking.exceeds': '⚠️ Exceeds table capacity ({n} seats)',
  'tables.booking.exceedsHint': 'Select a booking mode below to accommodate {n} guests.',
  'tables.booking.selectMode': 'Select Booking Mode',
  'tables.booking.join': '🔗 Join Tables',
  'tables.booking.joinHint': 'Combine multiple tables for larger parties',
  'tables.booking.share': '👥 Share Table',
  'tables.booking.shareHint': 'Share this table with another party',
  'tables.booking.override': '⚡ Manager Override',
  'tables.booking.overrideHint': 'Requires manager approval to exceed capacity',
  'tables.booking.joinPick': '🔗 Select Additional Tables to Join',
  'tables.booking.totalCapacity': 'Total Capacity:',
  'tables.booking.seatsNeeded': '👥 How many seats needed?',
  'tables.booking.seatsPlaceholder': 'Number of seats to allocate',
  'tables.booking.overrideRequired': '⚡ Manager Override Required',
  'tables.booking.staffId': 'Manager/Staff ID',
  'tables.booking.staffIdPlaceholder': 'Enter staff ID',
  'tables.booking.reason': 'Reason for Override',
  'tables.booking.reasonPlaceholder': 'Explain why capacity override is needed...',
  'tables.booking.guestDetails': 'Guest Details (Optional)',
  'tables.booking.guestName': 'Guest Name',
  'tables.booking.guestNamePlaceholder': 'Enter guest name',
  'tables.booking.guestPhone': 'Guest Phone',
  'tables.booking.guestPhonePlaceholder': 'Enter phone number',
  'tables.booking.bookNow': 'Book Immediately',
  'tables.booking.schedule': 'Schedule Appointment',

  // --- All Reservations ----------------------------------------------------
  'tables.res.eyebrow': 'Reservations · All upcoming',
  'tables.res.title': 'All Reservations',
  'tables.res.refresh': 'Refresh',
  'tables.res.loading': 'Loading reservations…',
  'tables.res.none': 'No upcoming reservations.',
  'tables.res.noMatches': 'No bookings match these filters.',
  'tables.res.dayCount': '{n} booking(s)',
  'tables.res.unscheduled': 'Unscheduled',
  'tables.res.dayToday': 'Today · {date}',
  'tables.res.dayTomorrow': 'Tomorrow · {date}',

  // Day control + column filters
  'tables.res.day.label': 'Day',
  'tables.res.day.title': 'Show only bookings for this day',
  'tables.res.day.all': 'All days',
  'tables.res.day.today': 'Today',
  'tables.res.day.tomorrow': 'Tomorrow',
  'tables.res.day.pick': 'Pick a date…',
  'tables.res.day.pickTitle': 'The day to show',
  'tables.res.filter.type': 'Show only bookings for this kind of visit',
  'tables.res.filter.status': 'Show only bookings with this status',
  'tables.res.filter.source': 'Show only bookings that came in this way',
  'tables.res.type.all': 'All types',
  'tables.res.status.all': 'All statuses',
  'tables.res.source.all': 'All sources',

  // Columns
  'tables.res.col.time': 'Time',
  'tables.res.col.guest': 'Guest',
  'tables.res.col.requestType': 'Request type',
  'tables.res.col.phone': 'Phone',
  'tables.res.col.pax': 'Pax',
  'tables.res.col.table': 'Table',
  'tables.res.col.advance': 'Advance received',
  'tables.res.col.source': 'Source',
  'tables.res.col.requestedAt': 'Requested at',
  'tables.res.col.approvedBy': 'Approved / Created by',

  // Booking source badges
  'tables.res.source.website': 'Website',
  'tables.res.source.phone': 'Phone',
  'tables.res.source.reception': 'Reception',

  // Reservation status labels
  'tables.res.awaitingApproval': 'Awaiting approval',
  'tables.res.confirmed': 'Confirmed',
  'tables.res.seated': 'Seated',
  'tables.res.completed': 'Completed',
  'tables.res.cancelled': 'Cancelled',
  'tables.res.noShowStatus': 'No-show',
  'tables.res.noShowsFilter': 'No-shows',

  // Advance-payment notes
  'tables.res.advance.pending': 'Not paid yet',
  'tables.res.advance.paid': 'Held for the bill',
  'tables.res.advance.applied': 'Adjusted in bill',
  'tables.res.advance.refunded': 'Refunded',
  'tables.res.advance.forfeited': 'Forfeited',
  'tables.res.appliedTitle': 'Booking amount deducted from the bill',
  'tables.res.appliedTitleOrder': 'Booking amount deducted from the bill (order {n})',
  'tables.res.deductedFrom': 'Deducted from order {n}',
  'tables.res.paid': 'Paid',

  // Row content
  'tables.res.changeTime': 'Change time',
  'tables.res.changeTimeTitle': 'Move this booking to another time — recorded in its history',
  'tables.res.crmTitle': 'Open customer profile (CRM)',
  'tables.res.buffet': 'Buffet',
  'tables.res.alacarte': 'A la carte',
  'tables.res.kids': '{adults}+{kids} kids',
  'tables.res.tableSeatsTitle': 'Table {code} seats {n}',
  'tables.res.seat.keep': 'Keep {code}',
  'tables.res.seat.noTable': 'No table yet',
  'tables.res.seat.random': 'Random free table',
  'tables.res.seat.unassignedArea': 'Unassigned area',
  'tables.res.seat.option': 'Table {code} · {n} seats',
  'tables.res.seat.title': 'Where to seat this party on approval',
  'tables.res.changeTable': 'Change table',
  'tables.res.preorder': 'Pre-order',
  'tables.res.preorderTitle': 'The guest pre-ordered — the kitchen starts it at check-in',
  'tables.res.orderBadge': 'Order {n}',
  'tables.res.orderBadgeTitle': 'Kitchen order created from this booking at check-in',
  'tables.res.createdBooking': 'Created the booking',
  'tables.res.approvedAt': 'Approved · {when}',
  'tables.res.approvedNoTime': 'Approved',
  'tables.res.autoApproved': 'Auto-approved',
  'tables.res.noApproverTitle': 'Nobody approved this booking — it ended while still undecided',
  'tables.res.bookedByStaff': 'Booked by staff',

  // Row actions
  'tables.res.approve': 'Approve',
  'tables.res.approveTitleKeeps': 'Approve — keeps table {code}',
  'tables.res.approveTitle': 'Approve this booking',
  'tables.res.decline': 'Decline',
  'tables.res.checkIn': 'Check in',
  'tables.res.checkingIn': 'Checking in…',
  'tables.res.checkinTooEarly': 'Check-in opens at {time} ({mins} min before the booking) — guest already here? Use Change time',
  'tables.res.checkinPreorderTitle': 'Seat the guest — their pre-order goes to the kitchen now',
  'tables.res.checkinTitle': 'Seat the guest at their booked table',
  'tables.res.extendHold': 'Extend hold',
  'tables.res.extendHoldTitle': 'Keep the table held longer — recorded in the booking\'s history',
  'tables.res.noShow': 'No show',
  'tables.res.noShowTitle': 'The party never arrived — releases the table and counts on the guest\'s profile',
  'tables.res.history': 'History',
  'tables.res.historyTitle': 'Every decision made on this booking — approvals, hold extensions, cancellation or no-show',

  // Change-time panel
  'tables.res.moveTo': 'Move this booking to…',
  'tables.res.now': 'Now — guest is here',
  'tables.res.nowTitle': 'The guest is standing here — move the booking to right now',
  'tables.res.moving': 'Moving…',
  'tables.res.moveBooking': 'Move booking',
  'tables.res.checkinOpensNote': 'Check-in opens {mins} min before the booked time; the move is recorded in the booking\'s history.',

  // Extend-hold panel
  'tables.res.holdAnother': 'Keep the table held for another…',
  'tables.res.plusMin': '+{n} min',
  'tables.res.customMins': 'Custom',
  'tables.res.extensionRecorded': 'The extension is recorded in the booking\'s history.',

  // Audit trail
  'tables.res.loadingHistory': 'Loading history…',
  'tables.res.noDecisions': 'No decisions recorded on this booking yet.',
  'tables.res.by': 'by',
  'tables.res.audit.approved': 'Approved',
  'tables.res.audit.declined': 'Declined',
  'tables.res.audit.cancelled': 'Cancelled',
  'tables.res.audit.autoCancelled': 'Auto-cancelled — hold ran out',
  'tables.res.audit.noShow': 'Marked no-show',
  'tables.res.audit.holdExtended': 'Hold extended',
  'tables.res.audit.rescheduled': 'Time changed',
  'tables.res.audit.advanceApplied': 'Advance adjusted in bill',
  'tables.res.audit.checkedIn': 'Checked in',
  'tables.res.audit.extended': '+{n} min',
  'tables.res.audit.extendedUntil': '+{n} min — held until {time}',
  'tables.res.audit.tableReleased': 'table {code} released',
  'tables.res.audit.table': 'table {code}',
  'tables.res.audit.wasHeldUntil': 'table was held until {time}',

  // Confirms, toasts & errors
  'tables.res.confirm.declineTitle': 'Decline this reservation?',
  'tables.res.confirm.cancelTitle': 'Cancel this reservation?',
  'tables.res.confirm.cancelDesc': '{name} · {pax} pax — the booking will be cancelled and the guest loses the table.',
  'tables.res.confirm.declineCta': 'Decline booking',
  'tables.res.confirm.cancelCta': 'Cancel booking',
  'tables.res.confirm.noShowTitle': 'Mark as a no-show?',
  'tables.res.confirm.noShowDesc': '{name} · {pax} pax — the table is released and the no-show is recorded on the guest\'s profile and in the booking\'s history. Use Cancel instead if they called to say they weren\'t coming.',
  'tables.res.confirm.noShowCta': 'Mark no-show',
  'tables.res.toast.approved': 'Reservation approved',
  'tables.res.toast.cancelled': 'Reservation cancelled',
  'tables.res.toast.noShow': 'Marked as a no-show',
  'tables.res.toast.declined': 'Reservation declined',
  'tables.res.toast.guestPax': '{name} · {pax} pax',
  'tables.res.toast.holdExtended': 'Hold extended by {n} min',
  'tables.res.toast.heldUntil': 'Table held until {time}',
  'tables.res.toast.extendFailed': 'Could not extend the hold',
  'tables.res.toast.timeChanged': 'Booking time changed',
  'tables.res.toast.timeChangedDesc': '{name} — now at {time}',
  'tables.res.toast.timeFailed': 'Could not change the time',
  'tables.res.toast.checkedIn': 'Guest checked in',
  'tables.res.toast.freeTablesFailed': 'Could not load free tables',
  'tables.res.err.failed': 'Failed',
  'tables.res.err.loadFailed': 'Failed to load reservations',
  'tables.res.err.checkinFailed': 'Check-in failed',

  // --- Create new reservation ---------------------------------------------
  'tables.newRes.title': 'Create new reservation',
  'tables.newRes.step.date': 'Date',
  'tables.newRes.step.time': 'Time',
  'tables.newRes.step.guests': 'Guests',
  'tables.newRes.step.area': 'Seating area',
  'tables.newRes.buffetServed': '{name} served {start}–{end}',
  'tables.newRes.openHours': 'Open {open}–{close}',
  'tables.newRes.lastOrders': 'last orders {last}',
  'tables.newRes.closedToday': 'Closed this day',
  'tables.newRes.dinnerHint': 'Dinner 18:00–23:00',
  'tables.newRes.lunchHint': 'Lunch 12:00–15:00',
  'tables.newRes.buffetNothingLeft': '{name} is served {start}–{end} — nothing left to book on this date.',
  'tables.newRes.branchClosed': 'The branch is closed on this day — pick another date.',
  'tables.newRes.showLunch': 'Show lunch times',
  'tables.newRes.showDinner': 'Show dinner times',
  'tables.newRes.today': 'Today',
  'tables.newRes.tomorrowShort': 'Tmrw',
  'tables.newRes.guestsLabel': 'guests',
  'tables.newRes.ofWhomChildren': 'of whom children',
  'tables.newRes.kidsAsAdults': 'priced and prepped as adults',
  'tables.newRes.adults.one': '{n} adult',
  'tables.newRes.adults.many': '{n} adults',
  'tables.newRes.children.one': '{n} child',
  'tables.newRes.children.many': '{n} children',
  'tables.newRes.oneChildFewer': 'One child fewer',
  'tables.newRes.oneChildMore': 'One child more',
  'tables.newRes.pickDateFirst': 'Pick a date and time first to see which areas are free.',
  'tables.newRes.checkingAvailability': 'Checking availability…',
  'tables.newRes.allFloors': 'All floors',
  'tables.newRes.allAreas': 'All areas',
  'tables.newRes.tableAvailable': 'A table is available here.',
  'tables.newRes.autoAssign.one': 'We\'ll assign the best free table for {n} guest automatically.',
  'tables.newRes.autoAssign.many': 'We\'ll assign the best free table for {n} guests automatically.',
  'tables.newRes.noFreeTableArea': 'No free table in this area for that time and party size. Try another area or time.',
  'tables.newRes.cta.pickDateTime': 'Select a date and time',
  'tables.newRes.cta.timePassed': 'That time has passed — pick another',
  'tables.newRes.cta.noFreeTable': 'No free table — try another time',
  'tables.newRes.cta.reserve': 'Reserve {code} · {day} · {time}',

  // Guest details modal
  'tables.newRes.whosComing': 'Who\'s coming?',
  'tables.newRes.tableLabel': 'Table',
  'tables.newRes.guestsCount': '{n} guests',
  'tables.newRes.minutes': '{n} min',
  'tables.newRes.bookingType': 'Booking type',
  'tables.newRes.walkIn': 'Walk-in',
  'tables.newRes.walkInHint': 'Guest at the counter, booking ahead',
  'tables.newRes.phone': 'Phone',
  'tables.newRes.phoneHint': 'Guest rang the restaurant',
  'tables.newRes.dining': 'Dining',
  'tables.newRes.alacarte': 'À la carte',
  'tables.newRes.alacarteHint': 'Ordering from the menu',
  'tables.newRes.buffet': 'Open buffet',
  'tables.newRes.buffetHint': 'Per-head buffet seating',
  'tables.newRes.pickBuffet': 'Pick a buffet…',
  'tables.newRes.perHead': '{price}/head',
  'tables.newRes.customerName': 'Customer name *',
  'tables.newRes.titlePlaceholder': 'Title',
  'tables.newRes.title.mr': 'Mr.',
  'tables.newRes.title.mrs': 'Mrs.',
  'tables.newRes.title.ms': 'Ms.',
  'tables.newRes.title.dr': 'Dr.',
  'tables.newRes.customerNamePlaceholder': 'Enter customer name',
  'tables.newRes.phoneNumber': 'Phone number',
  'tables.newRes.phonePlaceholder': 'Enter phone number',
  'tables.newRes.lookingUp': 'Looking up customer…',
  'tables.newRes.existingCustomer': 'Existing customer',
  'tables.newRes.visits': '{n} visits',
  'tables.newRes.spend': 'spend {amount}',
  'tables.newRes.lastVisit': 'last visit {date}',
  'tables.newRes.useThisName': 'Use this name',
  'tables.newRes.otp.verified': 'Phone number verified',
  'tables.newRes.otp.needPhone': 'Phone bookings need the number verified',
  'tables.newRes.otp.needWalkin': 'Walk-in bookings need the number verified',
  'tables.newRes.otp.sendAgain': 'Send again',
  'tables.newRes.otp.send': 'Send code',
  'tables.newRes.otp.verify': 'Verify',
  'tables.newRes.otp.codeAria': 'Verification code',
  'tables.newRes.otp.readOut': 'Read out: {code} (not texted)',
  'tables.newRes.otp.phoneNeeded': 'Phone needed',
  'tables.newRes.otp.phoneNeededDesc': 'Enter the guest’s phone number first.',
  'tables.newRes.otp.sendFailed': 'Could not send the code',
  'tables.newRes.otp.verifiedTitle': 'Phone verified',
  'tables.newRes.otp.verifiedDesc': 'The number on this booking is confirmed.',
  'tables.newRes.otp.invalid': 'That code is not valid',
  'tables.newRes.bookingMode': 'Booking mode',
  'tables.newRes.mode.exclusive': 'Exclusive',
  'tables.newRes.mode.share': 'Share',
  'tables.newRes.mode.join': 'Join',
  'tables.newRes.advanceAmount': 'Advance amount',
  'tables.newRes.loyaltyId': 'Loyalty ID',
  'tables.newRes.loyaltyPlaceholder': 'Member ID',
  'tables.newRes.tags': 'Tags (comma separated)',
  'tables.newRes.tagsPlaceholder': 'VIP, Allergy, Regular...',
  'tables.newRes.sendConfirmation': 'Send confirmation',
  'tables.newRes.scheduleReminder': 'Schedule reminder',
  'tables.newRes.back': 'Back',
  'tables.newRes.booking': 'Booking…',
  'tables.newRes.confirmBooking': 'Confirm booking',
  'tables.newRes.verifyFirst': 'Verify the guest’s phone number first',
  'tables.newRes.err.pastTitle': 'Invalid Date/Time',
  'tables.newRes.err.pastDesc': 'This reservation slot is now in the past. Please pick a future date and time.',
  'tables.newRes.err.validation': 'Validation Error',
  'tables.newRes.err.nameRequired': 'Please enter customer name',
  'tables.newRes.err.otpTitle': 'Phone not verified',
  'tables.newRes.err.otpDesc': 'This branch needs the guest’s number verified before the table is held.',
  'tables.newRes.err.buffetTitle': 'Which buffet?',
  'tables.newRes.err.buffetDesc': 'Pick the buffet the party is booking, or switch back to à la carte.',
  'tables.newRes.success': 'Booking Successful',
  'tables.newRes.successDesc': 'Table {code} has been reserved for {name}',
  'tables.newRes.failed': 'Booking Failed',
  'tables.newRes.failedDesc': 'Failed to book table',
  'tables.newRes.loadTablesFailed': 'Failed to load tables',

  // --- QR Codes screen (Self Service Orders → QR Codes) --------------------
  // Every code a guest can scan: one per table, the menu, the counter and the
  // booking page. The counter's one is the KIOSK QR — ordering with no table.
  'qr.title': 'QR Codes',
  'qr.generate': 'Generate',
  'qr.regenerate': 'Regenerate',
  'qr.generateQr': 'Generate QR',
  'qr.copy': 'Copy link',
  'qr.copied': 'Copied',
  'qr.download': 'Download',
  'qr.table': 'Table {code}',
  'qr.error.tables': 'Failed to load tables',
  'qr.error.tableQr': 'Failed to generate QR',
  'qr.error.tableQrNetwork': 'Network error generating QR',
  'qr.error.kiosk': 'Failed to generate the Customer Self Service QR',
  'qr.error.kioskNetwork': 'Network error generating the Customer Self Service QR',
  'qr.error.reserve': 'Failed to generate reservation link',
  'qr.error.reserveNetwork': 'Network error generating reservation link',
  'qr.kiosk.title': 'Customer Self Service QR',
  'qr.kiosk.blurb': 'One code for the branch: guests open it on their own phone, order and pay without a table number, and the order lands on this branch’s ONLINE counter as a guest-phone order. A kiosk is the RestoBOXX Kiosk application, registered under Settings → Devices — it needs no code from here.',
  'qr.kiosk.generate': 'Generate Customer Self Service QR',
  'qr.kiosk.branch': 'Branch: {name}',
  'qr.kiosk.alt': 'QR for ordering without a table',
  'qr.kiosk.cardSubtitle': 'Order Here',
  'qr.kiosk.cardHint2': 'Order and pay — no table needed',
  'qr.reserve.title': 'Reservation Link',
  'qr.reserve.pageSub': 'One link and QR for the whole restaurant, opening the public booking page. Put it on your website, your social profiles or a card at the desk — guests pick the branch, date and party size themselves.',
  'qr.reserve.generate': 'Generate Link & QR',
  'qr.reserve.alt': 'QR for the table reservation page',
  'qr.reserve.cardSubtitle': 'Reserve a Table',
  'qr.reserve.cardHint2': 'Pick a date, a time and your table',
  'qr.tables.loading': 'Loading tables…',
  'qr.tables.empty': 'No active tables found for this restaurant.',
  'qr.tables.pick': 'Pick a table',
  'qr.tables.title': 'Table QR Codes',
  'qr.tables.count': '{n} tables',
  'qr.tables.show': 'Show tables',
  'qr.tables.hide': 'Hide tables',
  'qr.tables.ready': 'QR ready',
  'qr.tables.noRoom': 'No room',
  'qr.tables.seats': '{n} seats',
  'qr.tables.alt': 'QR for table {code}',
  'qr.tables.hintBefore': 'Click',
  'qr.tables.hintAfter': 'to create a QR for this table.',
  'qr.card.hint': 'Point your phone camera at the code',
  'qr.card.tableHint2': 'Sit down, scan, and order from your seat',
  'qr.card.restaurantFallback': 'Our Restaurant',
};

export const fr = {
  'tables.designer.reservations': 'Réservations par téléphone / à l’accueil',
  'tables.designer.website': 'Réservation sur le site web',
  'tables.designer.allowed': 'Autorisée',
  'tables.designer.notAllowed': 'Non autorisée',
  'tables.designer.channelsHint': 'Quels canaux peuvent réserver cette table. Non autorisée la retire du choix de tables de ce canal et du placement automatique ; une réservation qui la nomme est refusée.',
  'tables.resv.held': 'Retenue — paiement en cours',
  'tables.resv.heldUntil': 'retenue jusqu’à {time}',
  'tables.audit.paymentExpired': 'Annulation automatique — délai de paiement dépassé',
  'tables.audit.blacklisted': 'Client mis sur liste noire — trop d’absences',
  // --- Shared by the tables & reservations screens -------------------------
  'tables.guest': 'Client',
  'tables.pax': '{n} couverts',
  'tables.seats': '{n} places',
  'tables.close': 'Fermer',
  'tables.error.title': 'Erreur',
  'tables.error.generic': 'Une erreur est survenue. Veuillez réessayer.',

  // --- Tables view: page chrome -------------------------------------------
  'tables.loading': 'Chargement des tables...',
  'tables.title': 'Gestion des tables',
  'tables.locationFallback': 'Point de vente {id}',
  'tables.stats.totalTables': 'Total tables',
  'tables.stats.totalSeats': 'Total places',
  'tables.stats.available': 'Libres',
  'tables.stats.occupied': 'Occupées',
  'tables.fetchFailed': 'Impossible de charger les tables',
  'tables.empty': 'Aucune table configurée pour ce point de vente. Ajoutez-les dans Salle → Plan de salle.',
  'tables.floor.tableCount': '({n} tables)',
  'tables.section.one': '{name} · 1 table',
  'tables.section.many': '{name} · {n} tables',

  // Reservation hold time card
  'tables.hold.label': 'Durée de maintien de la réservation',
  'tables.hold.minutes': 'minutes',
  'tables.hold.preset.min': '{n} min',
  'tables.hold.preset.hour1': '1 h',
  'tables.hold.preset.hour15': '1 h 30',
  'tables.hold.preset.hour2': '2 h',
  'tables.hold.saved': 'Enregistré ✓',
  'tables.hold.help': 'Durée pendant laquelle l’enregistrement par QR d’un client garde la table avant sa libération automatique.',
  'tables.hold.saveFailed.title': 'Enregistrement impossible',
  'tables.hold.saveFailed.desc': 'La durée de réservation n’a pas pu être mise à jour.',

  // --- Table card ----------------------------------------------------------
  'tables.card.viewOrders': 'Voir les commandes de cette table',
  'tables.card.shared.one': 'PARTAGÉE · {n} groupe',
  'tables.card.shared.many': 'PARTAGÉE · {n} groupes',
  'tables.sharing': 'en partage',
  'tables.takenBy': 'Prise par {name}',
  'tables.orderedBy': 'Commandée par {name}',
  'tables.bookTable': 'Réserver la table',
  'tables.freeTable': 'Libérer la table',

  // Table status badge — the LABEL only; the stored value never changes.
  'tables.status.available': 'LIBRE',
  'tables.status.reserved': 'RÉSERVÉE',
  'tables.status.occupied': 'OCCUPÉE',
  'tables.status.partial': 'PARTIELLE',

  // Order status badge labels
  'tables.orderStatus.pending': 'EN ATTENTE',
  'tables.orderStatus.ordered': 'COMMANDÉE',
  'tables.orderStatus.confirmed': 'CONFIRMÉE',
  'tables.orderStatus.preparing': 'EN PRÉPARATION',
  'tables.orderStatus.ready': 'PRÊTE',
  'tables.orderStatus.served': 'SERVIE',
  'tables.orderStatus.cancelled': 'ANNULÉE',
  'tables.orderStatus.completed': 'TERMINÉE',
  'tables.orderStatus.voided': 'SUPPRIMÉE',
  'tables.orderStatus.servedBillOpen': 'SERVIE — addition ouverte',

  // Per-line (dish) status labels
  'tables.itemStatus.pending': 'EN ATTENTE',
  'tables.itemStatus.preparing': 'EN PRÉPARATION',
  'tables.itemStatus.ready': 'PRÊT',
  'tables.itemStatus.served': 'SERVI',
  'tables.itemStatus.held': 'RETENU',

  // Per-line service clock
  'tables.clock.orderedServed': 'commandé {at} → servi {served} · {mins} min',
  'tables.clock.orderedServedNoMins': 'commandé {at} → servi {served}',
  'tables.clock.servedTimeUnknown': 'commandé {at} → servi (heure non enregistrée)',
  'tables.clock.orderedState': 'commandé {at} · {state} {mins} min',
  'tables.clock.orderedOnly': 'commandé {at}',
  'tables.clock.state.waiting': 'en attente',
  'tables.clock.state.cooking': 'en préparation',
  'tables.clock.state.ready': 'prêt au passe',

  // --- Free table / book table -------------------------------------------
  'tables.free.title': 'Libérer la table {code} ?',
  'tables.free.desc': 'Cela met fin au service de ces clients et rend la table disponible.',
  'tables.free.descUnserved.one': ' La table a encore 1 commande non servie — vous choisirez ensuite si vous l’annulez.',
  'tables.free.descUnserved.many': ' La table a encore {n} commandes non servies — vous choisirez ensuite si vous les annulez.',
  'tables.free.confirm': 'Libérer la table',
  'tables.free.cancelTitle.one': 'Annuler la commande non servie ?',
  'tables.free.cancelTitle.many': 'Annuler les {n} commandes non servies ?',
  'tables.free.cancelDesc.one': '{orders} n’a pas encore été servie. ',
  'tables.free.cancelDesc.many': '{orders} n’ont pas encore été servies. ',
  'tables.free.cancelDesc.explain': 'Annuler : la cuisine s’arrête et l’annulation est inscrite sur la commande. Garder : la cuisine poursuit et la commande reste ouverte.',
  'tables.free.cancelConfirm.one': 'Annuler la commande',
  'tables.free.cancelConfirm.many': 'Annuler les commandes',
  'tables.free.keepOrders': 'Garder les commandes',
  'tables.free.failed': 'Impossible de libérer la table',
  'tables.book.failed': 'Impossible de réserver la table : {msg}',

  // --- Marking food served -------------------------------------------------
  'tables.serve.orderFailed.title': 'Impossible de marquer la commande servie',
  'tables.serve.orderFailed.desc': 'La commande n’a pas été mise à jour — réessayez.',
  'tables.serve.itemFailed.title': 'Impossible de marquer le plat servi',
  'tables.serve.itemFailed.desc': 'Le plat n’a pas été mis à jour — réessayez.',

  // --- Table order sheet ---------------------------------------------------
  'tables.detail.loadFailed': 'Impossible de charger les commandes de cette table.',
  'tables.detail.title': '{code} — Commandes',
  'tables.detail.shared': 'PARTAGÉE · {n} groupes',
  'tables.detail.loading': 'Chargement des commandes…',
  'tables.detail.activeOrders': 'Commandes en cours ({n})',
  'tables.detail.noActive': 'Aucune commande en cours sur cette table.',
  'tables.detail.noneFromParty': 'Aucune commande de ce groupe pour l’instant.',
  'tables.detail.otherActive': 'Autres commandes en cours',
  'tables.detail.history': 'Historique des commandes ({n})',
  'tables.detail.noHistory': 'Aucune commande passée sur cette table.',
  'tables.order.markServed': '✅ Marquer servie — le client l’a reçue',
  'tables.order.generateBill': 'Éditer l’addition — clôturer',
  'tables.order.for': 'pour',
  'tables.order.serveItem': '✓ Servir',
  'tables.order.comesWith': 'Servi avec {items}',
  'tables.order.total': 'Total',

  // --- Bill ---------------------------------------------------------------
  'tables.bill.loadFailed': 'Impossible de charger l’addition.',
  'tables.bill.title': 'Addition · {number}',
  'tables.bill.table': 'Table {code}',
  'tables.bill.working': 'Calcul de l’addition…',
  'tables.bill.subtotal': 'Sous-total',
  'tables.bill.advance': 'Acompte de réservation',
  'tables.bill.advanceAdjusted': 'Acompte de réservation (déduit)',
  'tables.bill.paid': 'Payée',
  'tables.bill.due': 'Montant dû',
  'tables.bill.paidClosed': 'PAYÉE — COMMANDE CLÔTURÉE',
  'tables.bill.print': 'Imprimer l’addition',
  'tables.bill.closing': 'Clôture…',
  'tables.bill.markPaid': 'Marquer payée et clôturer',
  'tables.bill.note': 'Imprimez-la d’abord si le client souhaite la voir. « Marquer payée » clôture la commande et utilise l’acompte éventuel ; la table reste occupée tant que vous ne la libérez pas.',
  'tables.bill.closeFailed.title': 'Impossible de clôturer la commande',
  'tables.bill.closeFailed.desc': 'La commande n’a pas été mise à jour — réessayez.',
  'tables.print.blocked.title': 'Fenêtre bloquée',
  'tables.print.blocked.desc': 'Autorisez les fenêtres pop-up sur ce site pour imprimer l’addition.',

  // --- Guest card ----------------------------------------------------------
  'tables.guestLink.title': 'Voir la fiche de ce client',
  'tables.guestCard.loadFailed': 'Impossible de charger ce client.',
  'tables.guestCard.registered': 'Client enregistré',
  'tables.guestCard.inactive': 'Compte inactif',
  'tables.guestCard.looking': 'Recherche du client…',
  'tables.guestCard.notRegisteredPhone': 'Client non enregistré — seul le nom a été pris lors de la réservation, et le numéro ne figure pas encore au fichier clients.',
  'tables.guestCard.notRegisteredNoPhone': 'Client non enregistré — seul le nom a été pris avec la commande, aucun numéro de téléphone au fichier.',
  'tables.guestCard.noEmail': 'pas d’e-mail',
  'tables.guestCard.visits': 'Visites',
  'tables.guestCard.totalSpend': 'Total dépensé',
  'tables.guestCard.avgOrder': 'Panier moyen',
  'tables.guestCard.lastVisit': 'Dernière visite',
  'tables.guestCard.usualParty': 'Groupe habituel',
  'tables.guestCard.noShows': 'Absences',
  'tables.guestCard.advanceHeld': 'Acompte de réservation retenu :',
  'tables.guestCard.advanceNote': ' — déduit de sa prochaine addition',
  'tables.guestCard.favourites': 'Plats préférés',
  'tables.guestCard.openCrm': 'Ouvrir la fiche CRM complète',

  // --- Booking modal (tables view) ----------------------------------------
  'tables.booking.title': 'Réserver {code}',
  'tables.booking.type': 'Type de réservation',
  'tables.booking.immediate': 'Immédiate',
  'tables.booking.immediateHint': 'Installer les clients maintenant',
  'tables.booking.appointment': 'Sur rendez-vous',
  'tables.booking.appointmentHint': 'Réserver pour plus tard',
  'tables.booking.dateTime': 'Date et heure du rendez-vous',
  'tables.booking.selected': 'Sélectionné :',
  'tables.booking.guests': 'Nombre de couverts',
  'tables.booking.guestsPlaceholder': 'Combien de couverts ?',
  'tables.booking.exceeds': '⚠️ Dépasse la capacité de la table ({n} places)',
  'tables.booking.exceedsHint': 'Choisissez un mode ci-dessous pour accueillir {n} couverts.',
  'tables.booking.selectMode': 'Choisir le mode de réservation',
  'tables.booking.join': '🔗 Joindre des tables',
  'tables.booking.joinHint': 'Combiner plusieurs tables pour les grands groupes',
  'tables.booking.share': '👥 Partager la table',
  'tables.booking.shareHint': 'Partager cette table avec un autre groupe',
  'tables.booking.override': '⚡ Dérogation du responsable',
  'tables.booking.overrideHint': 'Nécessite l’accord du responsable pour dépasser la capacité',
  'tables.booking.joinPick': '🔗 Sélectionner les tables à joindre',
  'tables.booking.totalCapacity': 'Capacité totale :',
  'tables.booking.seatsNeeded': '👥 Combien de places faut-il ?',
  'tables.booking.seatsPlaceholder': 'Nombre de places à attribuer',
  'tables.booking.overrideRequired': '⚡ Dérogation du responsable requise',
  'tables.booking.staffId': 'ID responsable / employé',
  'tables.booking.staffIdPlaceholder': 'Saisir l’ID de l’employé',
  'tables.booking.reason': 'Motif de la dérogation',
  'tables.booking.reasonPlaceholder': 'Expliquez pourquoi la dérogation est nécessaire...',
  'tables.booking.guestDetails': 'Coordonnées du client (facultatif)',
  'tables.booking.guestName': 'Nom du client',
  'tables.booking.guestNamePlaceholder': 'Saisir le nom du client',
  'tables.booking.guestPhone': 'Téléphone du client',
  'tables.booking.guestPhonePlaceholder': 'Saisir le numéro de téléphone',
  'tables.booking.bookNow': 'Réserver immédiatement',
  'tables.booking.schedule': 'Planifier le rendez-vous',

  // --- All Reservations ----------------------------------------------------
  'tables.res.eyebrow': 'Réservations · Toutes à venir',
  'tables.res.title': 'Toutes les réservations',
  'tables.res.refresh': 'Actualiser',
  'tables.res.loading': 'Chargement des réservations…',
  'tables.res.none': 'Aucune réservation à venir.',
  'tables.res.noMatches': 'Aucune réservation ne correspond à ces filtres.',
  'tables.res.dayCount': '{n} réservation(s)',
  'tables.res.unscheduled': 'Sans date',
  'tables.res.dayToday': 'Aujourd’hui · {date}',
  'tables.res.dayTomorrow': 'Demain · {date}',

  // Day control + column filters
  'tables.res.day.label': 'Jour',
  'tables.res.day.title': 'N’afficher que les réservations de ce jour',
  'tables.res.day.all': 'Tous les jours',
  'tables.res.day.today': 'Aujourd’hui',
  'tables.res.day.tomorrow': 'Demain',
  'tables.res.day.pick': 'Choisir une date…',
  'tables.res.day.pickTitle': 'Le jour à afficher',
  'tables.res.filter.type': 'N’afficher que ce type de visite',
  'tables.res.filter.status': 'N’afficher que les réservations à ce statut',
  'tables.res.filter.source': 'N’afficher que les réservations reçues par ce canal',
  'tables.res.type.all': 'Tous les types',
  'tables.res.status.all': 'Tous les statuts',
  'tables.res.source.all': 'Toutes les sources',

  // Columns
  'tables.res.col.time': 'Heure',
  'tables.res.col.guest': 'Client',
  'tables.res.col.requestType': 'Type de demande',
  'tables.res.col.phone': 'Téléphone',
  'tables.res.col.pax': 'Couverts',
  'tables.res.col.table': 'Table',
  'tables.res.col.advance': 'Acompte reçu',
  'tables.res.col.source': 'Source',
  'tables.res.col.requestedAt': 'Demandée à',
  'tables.res.col.approvedBy': 'Approuvée / créée par',

  // Booking source badges
  'tables.res.source.website': 'Site web',
  'tables.res.source.phone': 'Téléphone',
  'tables.res.source.reception': 'Réception',

  // Reservation status labels
  'tables.res.awaitingApproval': 'En attente d’accord',
  'tables.res.confirmed': 'Confirmée',
  'tables.res.seated': 'Installée',
  'tables.res.completed': 'Terminée',
  'tables.res.cancelled': 'Annulée',
  'tables.res.noShowStatus': 'Absence',
  'tables.res.noShowsFilter': 'Absences',

  // Advance-payment notes
  'tables.res.advance.pending': 'Pas encore payé',
  'tables.res.advance.paid': 'Retenu pour l’addition',
  'tables.res.advance.applied': 'Déduit de l’addition',
  'tables.res.advance.refunded': 'Remboursé',
  'tables.res.advance.forfeited': 'Perdu',
  'tables.res.appliedTitle': 'Montant de la réservation déduit de l’addition',
  'tables.res.appliedTitleOrder': 'Montant de la réservation déduit de l’addition (commande {n})',
  'tables.res.deductedFrom': 'Déduit de la commande {n}',
  'tables.res.paid': 'Payé',

  // Row content
  'tables.res.changeTime': 'Changer l’heure',
  'tables.res.changeTimeTitle': 'Déplacer cette réservation à une autre heure — inscrit dans son historique',
  'tables.res.crmTitle': 'Ouvrir la fiche client (CRM)',
  'tables.res.buffet': 'Buffet',
  'tables.res.alacarte': 'À la carte',
  'tables.res.kids': '{adults}+{kids} enfants',
  'tables.res.tableSeatsTitle': 'La table {code} compte {n} places',
  'tables.res.seat.keep': 'Garder {code}',
  'tables.res.seat.noTable': 'Aucune table pour l’instant',
  'tables.res.seat.random': 'Table libre au hasard',
  'tables.res.seat.unassignedArea': 'Zone non attribuée',
  'tables.res.seat.option': 'Table {code} · {n} places',
  'tables.res.seat.title': 'Où installer ce groupe à l’accord',
  'tables.res.changeTable': 'Changer de table',
  'tables.res.preorder': 'Précommande',
  'tables.res.preorderTitle': 'Le client a précommandé — la cuisine lance à l’arrivée',
  'tables.res.orderBadge': 'Commande {n}',
  'tables.res.orderBadgeTitle': 'Commande cuisine créée à partir de cette réservation à l’arrivée',
  'tables.res.createdBooking': 'A créé la réservation',
  'tables.res.approvedAt': 'Approuvée · {when}',
  'tables.res.approvedNoTime': 'Approuvée',
  'tables.res.autoApproved': 'Approuvée automatiquement',
  'tables.res.noApproverTitle': 'Personne n’a approuvé cette réservation — elle s’est terminée sans décision',
  'tables.res.bookedByStaff': 'Réservée par le personnel',

  // Row actions
  'tables.res.approve': 'Approuver',
  'tables.res.approveTitleKeeps': 'Approuver — garde la table {code}',
  'tables.res.approveTitle': 'Approuver cette réservation',
  'tables.res.decline': 'Refuser',
  'tables.res.checkIn': 'Enregistrer l’arrivée',
  'tables.res.checkingIn': 'Enregistrement…',
  'tables.res.checkinTooEarly': 'L’arrivée s’ouvre à {time} ({mins} min avant la réservation) — le client est déjà là ? Utilisez Changer l’heure',
  'tables.res.checkinPreorderTitle': 'Installer le client — sa précommande part en cuisine maintenant',
  'tables.res.checkinTitle': 'Installer le client à la table réservée',
  'tables.res.extendHold': 'Prolonger le maintien',
  'tables.res.extendHoldTitle': 'Garder la table plus longtemps — inscrit dans l’historique de la réservation',
  'tables.res.noShow': 'Absence',
  'tables.res.noShowTitle': 'Le groupe n’est jamais venu — libère la table et compte sur la fiche du client',
  'tables.res.history': 'Historique',
  'tables.res.historyTitle': 'Toutes les décisions prises sur cette réservation — accords, prolongations, annulation ou absence',

  // Change-time panel
  'tables.res.moveTo': 'Déplacer cette réservation à…',
  'tables.res.now': 'Maintenant — le client est là',
  'tables.res.nowTitle': 'Le client est devant vous — déplacer la réservation à maintenant',
  'tables.res.moving': 'Déplacement…',
  'tables.res.moveBooking': 'Déplacer la réservation',
  'tables.res.checkinOpensNote': 'L’arrivée s’ouvre {mins} min avant l’heure réservée ; le déplacement est inscrit dans l’historique de la réservation.',

  // Extend-hold panel
  'tables.res.holdAnother': 'Garder la table encore…',
  'tables.res.plusMin': '+{n} min',
  'tables.res.customMins': 'Autre',
  'tables.res.extensionRecorded': 'La prolongation est inscrite dans l’historique de la réservation.',

  // Audit trail
  'tables.res.loadingHistory': 'Chargement de l’historique…',
  'tables.res.noDecisions': 'Aucune décision enregistrée sur cette réservation.',
  'tables.res.by': 'par',
  'tables.res.audit.approved': 'Approuvée',
  'tables.res.audit.declined': 'Refusée',
  'tables.res.audit.cancelled': 'Annulée',
  'tables.res.audit.autoCancelled': 'Annulée automatiquement — maintien expiré',
  'tables.res.audit.noShow': 'Marquée absence',
  'tables.res.audit.holdExtended': 'Maintien prolongé',
  'tables.res.audit.rescheduled': 'Heure modifiée',
  'tables.res.audit.advanceApplied': 'Acompte déduit de l’addition',
  'tables.res.audit.checkedIn': 'Arrivée enregistrée',
  'tables.res.audit.extended': '+{n} min',
  'tables.res.audit.extendedUntil': '+{n} min — table gardée jusqu’à {time}',
  'tables.res.audit.tableReleased': 'table {code} libérée',
  'tables.res.audit.table': 'table {code}',
  'tables.res.audit.wasHeldUntil': 'la table était gardée jusqu’à {time}',

  // Confirms, toasts & errors
  'tables.res.confirm.declineTitle': 'Refuser cette réservation ?',
  'tables.res.confirm.cancelTitle': 'Annuler cette réservation ?',
  'tables.res.confirm.cancelDesc': '{name} · {pax} couverts — la réservation sera annulée et le client perd la table.',
  'tables.res.confirm.declineCta': 'Refuser la réservation',
  'tables.res.confirm.cancelCta': 'Annuler la réservation',
  'tables.res.confirm.noShowTitle': 'Marquer comme absence ?',
  'tables.res.confirm.noShowDesc': '{name} · {pax} couverts — la table est libérée et l’absence est inscrite sur la fiche du client et dans l’historique de la réservation. Utilisez plutôt Annuler s’il a appelé pour se décommander.',
  'tables.res.confirm.noShowCta': 'Marquer absence',
  'tables.res.toast.approved': 'Réservation approuvée',
  'tables.res.toast.cancelled': 'Réservation annulée',
  'tables.res.toast.noShow': 'Marquée comme absence',
  'tables.res.toast.declined': 'Réservation refusée',
  'tables.res.toast.guestPax': '{name} · {pax} couverts',
  'tables.res.toast.holdExtended': 'Maintien prolongé de {n} min',
  'tables.res.toast.heldUntil': 'Table gardée jusqu’à {time}',
  'tables.res.toast.extendFailed': 'Impossible de prolonger le maintien',
  'tables.res.toast.timeChanged': 'Heure de la réservation modifiée',
  'tables.res.toast.timeChangedDesc': '{name} — désormais à {time}',
  'tables.res.toast.timeFailed': 'Impossible de changer l’heure',
  'tables.res.toast.checkedIn': 'Arrivée du client enregistrée',
  'tables.res.toast.freeTablesFailed': 'Impossible de charger les tables libres',
  'tables.res.err.failed': 'Échec',
  'tables.res.err.loadFailed': 'Impossible de charger les réservations',
  'tables.res.err.checkinFailed': 'Échec de l’enregistrement de l’arrivée',

  // --- Create new reservation ---------------------------------------------
  'tables.newRes.title': 'Créer une réservation',
  'tables.newRes.step.date': 'Date',
  'tables.newRes.step.time': 'Heure',
  'tables.newRes.step.guests': 'Couverts',
  'tables.newRes.step.area': 'Zone de salle',
  'tables.newRes.buffetServed': '{name} servi de {start} à {end}',
  'tables.newRes.openHours': 'Ouvert {open}–{close}',
  'tables.newRes.lastOrders': 'dernières commandes {last}',
  'tables.newRes.closedToday': 'Fermé ce jour',
  'tables.newRes.dinnerHint': 'Dîner 18:00–23:00',
  'tables.newRes.lunchHint': 'Déjeuner 12:00–15:00',
  'tables.newRes.buffetNothingLeft': '{name} est servi de {start} à {end} — plus rien à réserver à cette date.',
  'tables.newRes.branchClosed': 'L’établissement est fermé ce jour-là — choisissez une autre date.',
  'tables.newRes.showLunch': 'Voir les heures du déjeuner',
  'tables.newRes.showDinner': 'Voir les heures du dîner',
  'tables.newRes.today': 'Auj.',
  'tables.newRes.tomorrowShort': 'Dem.',
  'tables.newRes.guestsLabel': 'couverts',
  'tables.newRes.ofWhomChildren': 'dont enfants',
  'tables.newRes.kidsAsAdults': 'comptés et servis comme des adultes',
  'tables.newRes.adults.one': '{n} adulte',
  'tables.newRes.adults.many': '{n} adultes',
  'tables.newRes.children.one': '{n} enfant',
  'tables.newRes.children.many': '{n} enfants',
  'tables.newRes.oneChildFewer': 'Un enfant de moins',
  'tables.newRes.oneChildMore': 'Un enfant de plus',
  'tables.newRes.pickDateFirst': 'Choisissez d’abord une date et une heure pour voir les zones libres.',
  'tables.newRes.checkingAvailability': 'Vérification des disponibilités…',
  'tables.newRes.allFloors': 'Tous les étages',
  'tables.newRes.allAreas': 'Toutes les zones',
  'tables.newRes.tableAvailable': 'Une table est disponible ici.',
  'tables.newRes.autoAssign.one': 'Nous attribuerons automatiquement la meilleure table libre pour {n} couvert.',
  'tables.newRes.autoAssign.many': 'Nous attribuerons automatiquement la meilleure table libre pour {n} couverts.',
  'tables.newRes.noFreeTableArea': 'Aucune table libre dans cette zone pour cette heure et ce nombre de couverts. Essayez une autre zone ou une autre heure.',
  'tables.newRes.cta.pickDateTime': 'Choisissez une date et une heure',
  'tables.newRes.cta.timePassed': 'Cette heure est passée — choisissez-en une autre',
  'tables.newRes.cta.noFreeTable': 'Aucune table libre — essayez une autre heure',
  'tables.newRes.cta.reserve': 'Réserver {code} · {day} · {time}',

  // Guest details modal
  'tables.newRes.whosComing': 'Qui vient ?',
  'tables.newRes.tableLabel': 'Table',
  'tables.newRes.guestsCount': '{n} couverts',
  'tables.newRes.minutes': '{n} min',
  'tables.newRes.bookingType': 'Type de réservation',
  'tables.newRes.walkIn': 'Sur place',
  'tables.newRes.walkInHint': 'Client au comptoir, qui réserve à l’avance',
  'tables.newRes.phone': 'Téléphone',
  'tables.newRes.phoneHint': 'Le client a appelé le restaurant',
  'tables.newRes.dining': 'Formule',
  'tables.newRes.alacarte': 'À la carte',
  'tables.newRes.alacarteHint': 'Commande à la carte',
  'tables.newRes.buffet': 'Buffet à volonté',
  'tables.newRes.buffetHint': 'Buffet au prix par personne',
  'tables.newRes.pickBuffet': 'Choisir un buffet…',
  'tables.newRes.perHead': '{price}/pers.',
  'tables.newRes.customerName': 'Nom du client *',
  'tables.newRes.titlePlaceholder': 'Civilité',
  'tables.newRes.title.mr': 'M.',
  'tables.newRes.title.mrs': 'Mme',
  'tables.newRes.title.ms': 'Mlle',
  'tables.newRes.title.dr': 'Dr',
  'tables.newRes.customerNamePlaceholder': 'Saisir le nom du client',
  'tables.newRes.phoneNumber': 'Numéro de téléphone',
  'tables.newRes.phonePlaceholder': 'Saisir le numéro de téléphone',
  'tables.newRes.lookingUp': 'Recherche du client…',
  'tables.newRes.existingCustomer': 'Client existant',
  'tables.newRes.visits': '{n} visites',
  'tables.newRes.spend': 'dépensé {amount}',
  'tables.newRes.lastVisit': 'dernière visite {date}',
  'tables.newRes.useThisName': 'Utiliser ce nom',
  'tables.newRes.otp.verified': 'Numéro de téléphone vérifié',
  'tables.newRes.otp.needPhone': 'Les réservations par téléphone exigent un numéro vérifié',
  'tables.newRes.otp.needWalkin': 'Les réservations sur place exigent un numéro vérifié',
  'tables.newRes.otp.sendAgain': 'Renvoyer',
  'tables.newRes.otp.send': 'Envoyer le code',
  'tables.newRes.otp.verify': 'Vérifier',
  'tables.newRes.otp.codeAria': 'Code de vérification',
  'tables.newRes.otp.readOut': 'À dicter : {code} (non envoyé par SMS)',
  'tables.newRes.otp.phoneNeeded': 'Téléphone requis',
  'tables.newRes.otp.phoneNeededDesc': 'Saisissez d’abord le numéro du client.',
  'tables.newRes.otp.sendFailed': 'Impossible d’envoyer le code',
  'tables.newRes.otp.verifiedTitle': 'Téléphone vérifié',
  'tables.newRes.otp.verifiedDesc': 'Le numéro de cette réservation est confirmé.',
  'tables.newRes.otp.invalid': 'Ce code n’est pas valide',
  'tables.newRes.bookingMode': 'Mode de réservation',
  'tables.newRes.mode.exclusive': 'Exclusive',
  'tables.newRes.mode.share': 'Partagée',
  'tables.newRes.mode.join': 'Tables jointes',
  'tables.newRes.advanceAmount': 'Montant de l’acompte',
  'tables.newRes.loyaltyId': 'N° de fidélité',
  'tables.newRes.loyaltyPlaceholder': 'N° de membre',
  'tables.newRes.tags': 'Étiquettes (séparées par des virgules)',
  'tables.newRes.tagsPlaceholder': 'VIP, Allergie, Habitué...',
  'tables.newRes.sendConfirmation': 'Envoyer la confirmation',
  'tables.newRes.scheduleReminder': 'Programmer un rappel',
  'tables.newRes.back': 'Retour',
  'tables.newRes.booking': 'Réservation…',
  'tables.newRes.confirmBooking': 'Confirmer la réservation',
  'tables.newRes.verifyFirst': 'Vérifiez d’abord le numéro du client',
  'tables.newRes.err.pastTitle': 'Date/heure invalide',
  'tables.newRes.err.pastDesc': 'Ce créneau est désormais passé. Choisissez une date et une heure à venir.',
  'tables.newRes.err.validation': 'Erreur de saisie',
  'tables.newRes.err.nameRequired': 'Veuillez saisir le nom du client',
  'tables.newRes.err.otpTitle': 'Téléphone non vérifié',
  'tables.newRes.err.otpDesc': 'Cet établissement exige la vérification du numéro du client avant de garder la table.',
  'tables.newRes.err.buffetTitle': 'Quel buffet ?',
  'tables.newRes.err.buffetDesc': 'Choisissez le buffet réservé par le groupe, ou revenez à la carte.',
  'tables.newRes.success': 'Réservation confirmée',
  'tables.newRes.successDesc': 'La table {code} est réservée pour {name}',
  'tables.newRes.failed': 'Échec de la réservation',
  'tables.newRes.failedDesc': 'Impossible de réserver la table',
  'tables.newRes.loadTablesFailed': 'Impossible de charger les tables',

  // --- QR Codes screen (Self Service Orders → QR Codes) --------------------
  // Les noms des écrans de navigation restent en anglais : c'est ce que la
  // barre latérale affiche, quelle que soit la langue choisie.
  'qr.title': 'Codes QR',
  'qr.generate': 'Générer',
  'qr.regenerate': 'Régénérer',
  'qr.generateQr': 'Générer le QR',
  'qr.copy': 'Copier le lien',
  'qr.copied': 'Copié',
  'qr.download': 'Télécharger',
  'qr.table': 'Table {code}',
  'qr.error.tables': 'Échec du chargement des tables',
  'qr.error.tableQr': 'Échec de la génération du QR',
  'qr.error.tableQrNetwork': 'Erreur réseau lors de la génération du QR',
  'qr.error.kiosk': 'Échec de la génération du QR libre-service client',
  'qr.error.kioskNetwork': 'Erreur réseau lors de la génération du QR libre-service client',
  'qr.error.reserve': 'Échec de la génération du lien de réservation',
  'qr.error.reserveNetwork': 'Erreur réseau lors de la génération du lien de réservation',
  'qr.kiosk.title': 'QR libre-service client',
  'qr.kiosk.blurb': 'Un seul code pour la succursale : le client l’ouvre sur son propre téléphone, commande et paie sans numéro de table, et la commande arrive sur le comptoir ONLINE de cette succursale. Une borne, c’est l’application RestoBOXX Kiosk, enregistrée sous Réglages → Appareils — elle n’a besoin d’aucun code ici.',
  'qr.kiosk.generate': 'Générer le QR libre-service client',
  'qr.kiosk.branch': 'Succursale : {name}',
  'qr.kiosk.alt': 'QR pour commander sans table',
  'qr.kiosk.cardSubtitle': 'Commandez ici',
  'qr.kiosk.cardHint2': 'Commandez et payez — sans table',
  'qr.reserve.title': 'Lien de réservation',
  'qr.reserve.pageSub': 'Un seul lien et QR pour tout le restaurant, ouvrant la page de réservation publique. À mettre sur votre site, vos réseaux sociaux ou une carte à l’accueil — les clients choisissent eux-mêmes l’établissement, la date et le nombre de convives.',
  'qr.reserve.generate': 'Générer le lien et le QR',
  'qr.reserve.alt': 'QR de la page de réservation de table',
  'qr.reserve.cardSubtitle': 'Réservez une table',
  'qr.reserve.cardHint2': 'Choisissez une date, une heure et votre table',
  'qr.tables.loading': 'Chargement des tables…',
  'qr.tables.empty': 'Aucune table active pour ce restaurant.',
  'qr.tables.pick': 'Choisissez une table',
  'qr.tables.title': 'Codes QR des tables',
  'qr.tables.count': '{n} tables',
  'qr.tables.show': 'Afficher les tables',
  'qr.tables.hide': 'Masquer les tables',
  'qr.tables.ready': 'QR prêt',
  'qr.tables.noRoom': 'Aucune salle',
  'qr.tables.seats': '{n} places',
  'qr.tables.alt': 'QR de la table {code}',
  'qr.tables.hintBefore': 'Cliquez sur',
  'qr.tables.hintAfter': 'pour créer un QR de cette table.',
  'qr.card.hint': 'Dirigez l’appareil photo de votre téléphone vers le code',
  'qr.card.tableHint2': 'Installez-vous, scannez et commandez depuis votre place',
  'qr.card.restaurantFallback': 'Notre restaurant',
};
